import {fromUrlToFilters, getSearchFilters, objectToArray, TAGS_FILTER_PARAM} from 'shared/lib/filterHelper';
import IOrderBy from 'shared/model/IOrderBy';

import IPortMonitorsFilters from 'features/port/model/PortMonitor/IPortMonitorsFilters';
import IPortIncidentFilters from 'features/port/model/PortIncident/IPortIncidentFilters';

export const PORT_MONITORS_DEFAULT_SORT: IOrderBy = {field: 'id', direction: 'desc'};

export const PORT_MONITORS_ORDER_FIELDS: readonly string[] = [
    'id',
    'name',
    'ip',
    'port',
    'status',
    'ok',
    'checkInterval',
    'lastCheck',
    'nextCheck',
];

export function getPortMonitorsFilters(params: URLSearchParams): IPortMonitorsFilters {
    const filters: IPortMonitorsFilters = {};
    fromUrlToFilters(params, filters, 'name');
    fromUrlToFilters(params, filters, 'ip');
    fromUrlToFilters(params, filters, 'port');
    fromUrlToFilters(params, filters, 'status');
    fromUrlToFilters(params, filters, 'ok');

    const tags = params.getAll(TAGS_FILTER_PARAM);
    if (tags.length > 0) {
        filters.tags = tags;
    }

    return filters;
}

export function getPortMonitorsFilterArray(params: URLSearchParams): string[] {
    return [...getSearchFilters(params), ...objectToArray(getPortMonitorsFilters(params))];
}

export const PORT_INCIDENTS_ORDER_FIELDS: readonly string[] = [
    'id',
    'resolved',
    'createdAt',
    'resolvedAt',
];

export const PORT_INCIDENT_FILTER_KEYS: readonly (keyof IPortIncidentFilters)[] = [
    'portMonitor.uuid',
    'resolved',
    'created_at[after]',
    'created_at[before]',
    'resolved_at[after]',
    'resolved_at[before]',
];

export function getPortIncidentFilters(params: URLSearchParams): IPortIncidentFilters {
    const filters: IPortIncidentFilters = {};
    PORT_INCIDENT_FILTER_KEYS.forEach(key => fromUrlToFilters(params, filters, key));

    return filters;
}
